import { ResourceAction } from './authorization-service';

export class AllowedActions {
  actions: ResourceAction[] = [];
  isLoading = false;

  constructor(actions: ResourceAction[], isLoading: boolean) {
    this.actions = actions;
    this.isLoading = isLoading;
  }

  private isAllowed(action: ResourceAction) {
    return this.actions.some(
      a => a.resourceType.toLowerCase() === action.resourceType.toLowerCase() && a.resourceOperation.toLowerCase() === action.resourceOperation.toLowerCase()
    );
  }

  isAnyAllowed(actions: ResourceAction[]) {
    return actions.some(a => this.isAllowed(a));
  }
}
